import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/layout/Layout";
import RequireAuth from "./components/layout/RequireAuth";
import AdminImports from "./pages/AdminImports";
import AdminUsers from "./pages/AdminUsers";
import Conversations from "./pages/Conversations";
import Reports from "./pages/Reports";
import Features from "./pages/Features";
import Insights from "./pages/Insights";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import PendingApproval from "./pages/PendingApproval";
import People from "./pages/People";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/pending-approval" element={<PendingApproval />} />

        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/" element={<Overview />} />
          <Route path="/people" element={<People />} />
          <Route path="/features" element={<Features />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/imports" element={<AdminImports />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
